import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { typography } from '@cld/typography';
import { Selectable, SelectableProps } from '../../common/selectable/Selectable';
import { Theme as ThemeType } from '../../../../types';
import { Theme, THEME_WIDTH, THEME_HEIGHT } from './Theme';

const MediumImg = styled.img`
  display: block;
  width: ${THEME_WIDTH}px;
  height: ${THEME_HEIGHT}px;
`;

const Text = styled.div`
  ${typography.xxs.regular};
  text-align: center;
  padding-top: ${globalTheme.spacing.xxs};
`;

export interface SelectableThemeProps extends SelectableProps {
  theme: ThemeType,
  themeIndex: number,
}

export const SelectableTheme: FC<SelectableThemeProps> = ({ isSelected, onClick, theme, themeIndex }) => (
  <div>
    <Selectable isSelected={isSelected} onClick={onClick} data-test={`theme-${themeIndex}`}>
      <Theme theme={theme} themeIndex={themeIndex}>
        {(themeSrc: string) => <MediumImg src={themeSrc} />}
      </Theme>
    </Selectable>
    <Text>{theme.name}</Text>
  </div>
);
